import { put, select, takeLatest } from 'redux-saga/effects'
// eslint-disable-next-line no-unused-vars
import { generateActivitiesByCategoriesTags } from '../actions'
import { getActivitiesMapWhereKeyIsCategoryTagId, getNumberOfDaysForGenerator } from '../selectors'
// @ts-ignore
import { actions } from 'store/entities/protracks/activities'
import { sliceActivities } from 'helpers/generator'

const countNumbersOfActions = (numbersOfActions: number[]): number => {
  return numbersOfActions.reduce((sum: number, number: number) => {
    sum = sum + number
    return sum
  }, 0)
}

export function* generateActivitiesByCategoriesTagsSagaHandler({ payload }: any) {
  try {
    const categoriesTagsActivities = yield select(getActivitiesMapWhereKeyIsCategoryTagId)
    const minimumPercentage = payload.get('minimumPercentage')
    const selectedCategoriesList = payload.get('categories')
    let arrayOfNewActivities = [] as Array<any>
    const numberOfDays = yield select(getNumberOfDaysForGenerator)
    const numbersOfActions = selectedCategoriesList
      .map((categoryTag: any) => {
        const percentage = parseInt(categoryTag.get('percentage'))
        return Math.round(percentage / minimumPercentage)
      })
      .toJS()
    const numbersOfActionsLength = numbersOfActions.length
    let sumOfNumbersOfActions = countNumbersOfActions(numbersOfActions)
    let i = 0
    while (sumOfNumbersOfActions > numberOfDays) {
      numbersOfActions[i] = numbersOfActions[i] - 1
      i++
      if (i === numbersOfActionsLength) {
        i = 0
      }
      sumOfNumbersOfActions = countNumbersOfActions(numbersOfActions)
    }
    let r = numbersOfActionsLength - 1
    while (sumOfNumbersOfActions < numberOfDays) {
      if (numbersOfActions[r] > 0) {
        numbersOfActions[r] = numbersOfActions[r] + 1
      }
      r--
      if (r === 0) {
        r = numbersOfActionsLength - 1
      }
      sumOfNumbersOfActions = countNumbersOfActions(numbersOfActions)
    }
    // TODO: @Serginyo90 write tests
    selectedCategoriesList.forEach((categoryTag: any, index: number) => {
      const numberOfActions = numbersOfActions[index]
      if (numberOfActions > 0) {
        const activities = categoriesTagsActivities.get(categoryTag.get('id'))
        const slicedActivities = sliceActivities(numberOfActions, activities.toJS())
        arrayOfNewActivities = arrayOfNewActivities.concat(slicedActivities)
      }
    })
    yield put(actions.addActivitiesFromFile(arrayOfNewActivities))
  } catch (e) {
    console.log('__error_inside_generateActivitiesByCategoriesTagsSagaHandler_', { e })
    throw new Error('_Error_inside_generateActivitiesByCategoriesTagsSagaHandler_')
  }
}

export default function* generateActivitiesByCategoriesTagsSaga() {
  yield takeLatest(generateActivitiesByCategoriesTags, generateActivitiesByCategoriesTagsSagaHandler)
}
